import Controller from '../abstracts/Controller';

export default class StoreLocatorController extends Controller {

  static get COMPONENTS() {
    return ["StoreLocatorComponent", "PrintComponent"];
  }
}
